export const ONLINE_COLUMN_DESCRIPTION_DATA = {
	headers: 'Column Name,Description',
	rows: [
		['Merchant ID', 'MID of the merchant'],
		['Merchant Order Id', 'Order ID sent by the merchant in the request'],
		[
			'Merchant Reference ID',
			'Reference ID sent by the merchant in the request',
		],
		[
			'Phonepe Order ID',
			'Unique Order ID created by PhonePe (Starting with OMO)',
		],
		[
			'Phonepe Transaction ID',
			'Unique Transaction ID created by PhonePe (Starting with OM)',
		],
		[
			'PhonePe Transaction Reference ID',
			'Unique Transaction Reference ID created by PhonePe (Starting with T)',
		],
		[
			'Product',
			'Product type is the product solution against which the transaction was initiated',
		],
		[
			'Transaction Type',
			'Transaction type is categorization of transactions within a product',
		],
		[
			'Transaction Date',
			'This is the transaction date which is the actual date on which transaction was processed',
		],
		[
			'Order Creation Date',
			'This is the order creation date which can be different from transaction date in Paylink and Subscription Redemption flows',
		],
		['Transaction Amount', 'This is the total transaction amount'],
		[
			'Instrument',
			'This is the instrument with which the transaction was initiated. There can be multiple instruments for a single transaction',
		],
		[
			'Mode',
			'Mode is further categorization within instrument. There can be multiple modes for a single transaction',
		],
		['Transaction Status', 'This is the terminal status of the transaction'],
		['Transaction UTR', 'Transaction UTR'],
		['UPI Amount', 'UPI amount of the total amount'],
		[
			'Net Banking',
			'Amount\tNet Banking amount of the total amount upto 2 decimal places',
		],
		[
			'Credit card Amount',
			'Credit Card amount of the total amount upto 2 decimal places',
		],
		[
			'Debit card Amount',
			'Debit Card amount of the total amount upto 2 decimal places',
		],
		[
			'Phonepe Wallet Amount',
			'Phonepe Wallet amount of the total amount upto 2 decimal places',
		],
		[
			'Phonepe EGV Amount',
			'Phonepe EGV amount of the total amount upto 2 decimal places',
		],
		['Settlement Date', 'Settlement Date'],
		[
			'Settlement UTR',
			'A UTR number is a unique identifier assigned to each financial transaction processed by banks. A UTR number is an alphanumeric code generated by banks when a transaction is executed.',
		],
		[
			'ARN',
			'An acquirer reference number or ARN; is a unique number created in credit or debit card transactions when it transfers from the merchant’s bank through the payment processor and to the cardholder’s bank',
		],
		['BRN', 'BRN'],
		['VPA', 'This is the VPA with which transaction was initiated'],
		['Flow Type', 'This is the type of UPI flow'],
		['Card Network', 'This is the network of the Card'],
		['Card AuthCode', 'This is a 6 digit code'],
		[
			'Card Variant',
			'This is the card variant based on the categorization done by Phonepe for charging purposes',
		],
		['International', 'This is a flag to tell if card is international or not'],
		['Card Number', 'Last 4 Digits of the card'],
		['Card BIN', 'This is the first 6-8 digits of the card'],
		[
			'Bank ID',
			'This is the 4 digit bank code. For UPI & NB; it is the bank of the account. In case of cards; it is the issuing bank',
		],
		['Fee Category', 'This is the fee category'],
		['Fee Type', 'This is fee type'],
		['Fee Value', 'This is the numeric value of the fees (rate)'],
		['Fee Amount', 'Fee Amount'],
		['IGST', 'IGST'],
		['CGST', 'CGST'],
		['SGST', 'SGST'],
		['Total Tax', 'Total Tax = IGST + CGST + SGST'],
		['Total Fees', 'Total Fees = Fee Amount + Total Tax'],
		['Net Amount', 'Net Amount = Transaction Amount - Total Fees'],
		['Field-1', 'Merchant defined field 1'],
		['Field-2', 'Merchant defined field 2'],
		['Field-3', 'Merchant defined field 3'],
		['Field-4', 'Merchant defined field 4'],
		['Field-5', 'Merchant defined field 5'],
		['Field-6', 'Merchant defined Field-6'],
		['Field-7', 'Merchant defined Field-7'],
		['Field-8', 'Merchant defined Field-8'],
		['Field-9', 'Merchant defined Field-9'],
		['Field-10', 'Merchant defined Field-10'],
		['Field-11', 'Merchant defined Field-11'],
		['Field-12', 'Merchant defined Field-12'],
		['Field-13', 'Merchant defined Field-13'],
		['Field-14', 'Merchant defined Field-14'],
		['Field-15', 'Merchant defined Field-15'],
		['Original Merchant Order ID', 'Merchant Order ID of forward transaction'],
		[
			'Original Merchant Reference ID',
			'Merchant Reference ID of forward transaction',
		],
		['Original Phonepe Order ID', 'Phonepe Order ID of forward transaction'],
		[
			'Original Phonepe Transaction ID',
			'Phonepe Transaction ID of forward transaction',
		],
		['Original Transaction Date', 'Transaction date of forward transaction'],
		[
			'Original Transaction Amount',
			'Transaction amount of forward transaction',
		],
		['Subscription ID', 'UMN Number'],
		['Subscription Amount', 'Subscription Amount'],
		['Frequency', 'Subscription frequency that is set internally'],
		['Authentication Type', 'Subscription authentication type'],
		['Currency', 'This will be INR in all the reports'],
		['Notes', 'This is the Notes passed by the merchant in the request'],
		['Creation Date', 'This will be the settlement report generation date'],
		['From', 'PhonePe Private Limited'],
		['Customer Name', 'Customer Name'],
	],
};
